import "./OurBadge.scss";

interface OurBadgeProps {
  status: "success" | "error" | "info";
  label: string;
}

export default function OurBadge({ status, label }: OurBadgeProps) {
  return <div className={`OurBadge ${status}`}>{label}</div>;
}
